/* istanbul ignore file */
import React from 'react'
import { Box, theme } from 'pcln-design-system'
import { bool, number, object, string } from 'prop-types'
import { FlexDateCell, StyledPopover, StyledText } from './FlexDatesRoundTrip.styles'
import { getText, getTileColor, handleClick, isPriceValid } from './HelpersCell'

/**
 * Green, Yellow, and Red Cells of the Grid
 */
export const ActiveFlexDateCell = ({
  cellProps,
  priceThreshold,
  price,
  isSelected = false,
  minimumRetailPrice,
  position,
  url,
  day,
}) => {
  // const [showPopover, setShowPopover] = useState(false)

  const { low, middle, high } = priceThreshold
  const isCheapest = price === low && price < middle

  // const handleMouseEnter = (e) => {
  //   e.preventDefault()
  //   setShowPopover(true)
  // }

  // const handleMouseLeave = (e) => {
  //   e.preventDefault()
  //   setShowPopover(false)
  // }

  // Opening popover when:
  // 1. Price valid (>0 and number)
  // 2. Not currently selected tile
  // 3. Not the same price - In the future we will revisit this when we add more items.
  //const isOpen = showPopover && isPriceValid(price) && !isSelected && price !== minimumRetailPrice

  return (
    <Box onClick={() => handleClick(price, url, day)}>
      <StyledPopover
        renderContent={() => (
          <Box p={2}>
            <StyledText color='secondary.base' textAlign='center' bold>
              {getText(minimumRetailPrice, price, isCheapest)}
            </StyledText>
          </Box>
        )}
        placement={'top'}
        ariaLabel='Bottonm Popover'
        width={'fit-content'}
        borderColor='border.dark'
        // isOpen={isOpen}
        hideOverlay
        toggleIsOpenOnClick={false}
        stopPropagation={false}
        display='block'
        idx={1}
        theme={theme}
        data-testid='flex-date-grid-popover'
      >
        <FlexDateCell
          // onMouseEnter={handleMouseEnter}
          // onMouseLeave={handleMouseLeave}
          {...cellProps}
          bg={getTileColor(price, middle, high, isSelected)}
          isSelected={isSelected}
          position={position}
          m={0}
          data-testid={'flex-date-grid-cell'}
        >
          <StyledText isCheapest={isCheapest && !isSelected} fontSize={1}>
            {isPriceValid(price) ? `$${Math.ceil(price)}` : '—'}
          </StyledText>
        </FlexDateCell>
      </StyledPopover>
    </Box>
  )
}

// Proptypes
ActiveFlexDateCell.propTypes = {
  cellProps: object,
  priceThreshold: object,
  price: number,
  isSelected: bool,
  minimumRetailPrice: number,
  position: number,
  url: string,
  day: string,
}
